module.exports = __webpack_public_path__ + "img/theme16.32dd8908.png";